import {
    BeltContainer,
    createBeltContainer,
} from '@vfde-brix/ws10/belt-container';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { startAppListening } from '../../../app/listener';
import { selectIsError } from '../selectors';

/**
 * Mount BeltContainers
 */
export const mountBeltContainers = (
    contentBeltContainerId: string,
    errorNotificationBeltContainerId: string,
) => {
    const contentBeltContainer = mountBeltContainer(contentBeltContainerId)!;
    const errorNotificationBeltContainer = mountBeltContainer(errorNotificationBeltContainerId);

    listenForUpdates(contentBeltContainer, errorNotificationBeltContainer);
};

/**
 * Mounts a BeltContainer by ID
 */
const mountBeltContainer = (containerId: string): BeltContainer | null => {
    const containerElement = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!containerElement) {
        return null;
    }

    return createBeltContainer(containerElement, NO_PATTERN_BUSINESS_LOGIC);
};

const listenForUpdates = (
    contentBeltContainer: BeltContainer,
    errorNotificationBeltContainer: BeltContainer | null,
) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectIsError(previousState) !== selectIsError(currentState),
        effect: (_action, api) => {
            const state = api.getState();
            const hasError = selectIsError(state);

            contentBeltContainer.toggleContainer(hasError);
            errorNotificationBeltContainer?.toggleContainer(!hasError);
        },
    });
};
